export class SectorWatchModel {
setValue(res){
if(res){
}
}
}